import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { MapleMark } from "./MapleMark";
import { EASE } from "../utils/motion";
type MonogramProps = {
  initials: string;
  name: string;
  image?: string;
  className?: string;
  tone?: "navy" | "red" | "stone";
  reveal?: boolean;
  /** CSS object-position for portraits, so faces stay in frame when cropped. */
  position?: string;
};
const TONES = {
  navy: "bg-[#061f38] text-[#f0b1b9]",
  red: "bg-[#8f1a2c] text-white",
  stone: "bg-[#e9e6df] text-[#061f38]"
};
export function Monogram({
  initials,
  name,
  image,
  className = "aspect-[4/5]",
  tone = "navy",
  reveal = false,
  position = "center 18%"
}: MonogramProps) {
  const reduce = useReducedMotion();
  const animate = reveal && !reduce;
  return <motion.div role="img" aria-label={image ? `Portrait of ${name}` : `${name}, official portrait to be supplied`} initial={{
    clipPath: animate ? "inset(100% 0 0 0)" : "inset(0% 0 0 0)"
  }} whileInView={{
    clipPath: "inset(0% 0 0 0)"
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: animate ? 0.9 : 0.01,
    ease: EASE
  }} className={`relative flex items-end justify-between overflow-hidden p-6 ${TONES[tone]} ${className}`} data-id="element-304" data-mp="2okr9foy0zp78">
      {image ? <img src={image} alt="" style={{
      objectPosition: position
    }} className="absolute inset-0 h-full w-full object-cover" data-id="element-305" data-mp="nn922irrwvi0" /> : <>
          <span className="text-[clamp(4rem,9vw,8rem)] font-medium leading-none tracking-[-0.08em]" data-id="element-306" data-mp="1bdd3cjhhoj5u">{initials}</span>
          <MapleMark size={26} className="mb-2 opacity-60" data-id="element-307" data-mp="1g9u2e8q88hxp" />
          <span className="absolute left-6 top-6 text-[10px] font-semibold tracking-[0.18em] opacity-60" data-id="element-308" data-mp="11dm7oeh6zy46">PORTRAIT TO BE SUPPLIED</span>
        </>}
    </motion.div>;
}